import { Box, Text, Tooltip as ChakraTooltip, Portal } from "@chakra-ui/react";
import { forwardRef, ReactNode, RefObject } from "react";

export type TooltipProps = ChakraTooltip.RootProps & {
  title?: string;
  showArrow?: boolean;
  portalled?: boolean;
  portalRef?: RefObject<HTMLElement>;
  content: ReactNode;
  contentProps?: ChakraTooltip.ContentProps;
  disabled?: boolean;
};

const Tooltip = forwardRef<HTMLDivElement, TooltipProps>((props, ref) => {
  const {
    title,
    showArrow,
    children,
    disabled,
    portalled = true,
    content,
    contentProps,
    portalRef,
    ...rest
  } = props;

  if (disabled) {
    return children;
  }

  return (
    <ChakraTooltip.Root {...rest}>
      <ChakraTooltip.Trigger asChild>{children}</ChakraTooltip.Trigger>

      <Portal disabled={!portalled} container={portalRef}>
        <ChakraTooltip.Positioner>
          <ChakraTooltip.Content ref={ref} {...contentProps}>
            {showArrow && (
              <ChakraTooltip.Arrow>
                <ChakraTooltip.ArrowTip />
              </ChakraTooltip.Arrow>
            )}

            <Box py={2} px={1} fontFamily="tooltip">
              {title && (
                <Text fontSize="sm" mb={3}>
                  Overall progress
                </Text>
              )}

              <Box fontSize="sm">{content}</Box>
            </Box>
          </ChakraTooltip.Content>
        </ChakraTooltip.Positioner>
      </Portal>
    </ChakraTooltip.Root>
  );
});

export default Tooltip;
